import axiosInstance from '../api/axiosInstance';

const cartService = {
    /**
     * Kullanıcının aktif sepetini getirir
     */
    getUserCart: async () => {
        const response = await axiosInstance.get('/carts/my-cart');
        return response.data;
    },

    /**
     * Sepete ürün ekler
     * @param {object} item - Sepete eklenecek ürün bilgileri
     * @param {string} item.productId - Ürün ID
     * @param {number} item.quantity - Ürün adedi
     * @param {string} item.note - Ürün için not (opsiyonel)
     */
    addItemToCart: async (item) => {
        const response = await axiosInstance.post('/carts/add-item', item);
        return response.data;
    },

    /**
     * Sepetteki ürünü günceller
     * @param {object} item - Güncellenecek ürün bilgileri
     * @param {string} item.cartItemId - Sepet öğesi ID
     * @param {number} item.quantity - Yeni adet
     * @param {string} item.note - Yeni not (opsiyonel)
     */
    updateCartItem: async (item) => {
        const response = await axiosInstance.put('/carts/update-item', item);
        return response.data;
    },

    /**
     * Sepetten ürün çıkarır
     * @param {string} itemId - Sepet öğesi ID
     */
    removeCartItem: async (itemId) => {
        const response = await axiosInstance.delete(`/carts/remove-item/${itemId}`);
        return response.data;
    },

    /**
     * Sepeti temizler
     */
    clearCart: async () => {
        const response = await axiosInstance.delete('/carts/clear');
        return response.data;
    },

    /**
     * Add a custom package to the cart
     * @param {object} packageData - Custom package payload
     * @param {Array} packageData.items - List of items ({ productId, quantity, weightGrams, unitPrice })
     */
    addCustomPackage: async (packageData) => {
        const response = await axiosInstance.post('/carts/add-custom-package', packageData);
        return response.data;
    },

    /**
     * Remove a custom package from the cart
     * @param {string} customPackageId - Custom package ID
     */
    removeCustomPackage: async (customPackageId) => {
        const response = await axiosInstance.delete(`/carts/remove-custom-package/${customPackageId}`);
        return response.data;
    }
};

export default cartService; 